import { LegalClientEntity } from 'api/types/entity';
import { parseFullName } from 'helpers';

import { LegalClientMainInfoType } from '../types';

export const getLegalClientMainInfo = (
  legalClient: LegalClientEntity
): LegalClientMainInfoType => ({
  representativeFullName: legalClient.representative
    ? parseFullName(legalClient.representative)
    : undefined,
  representativeEmail: legalClient.representative?.email,
  representativePhone: legalClient.representative?.phoneNumber,
  country: legalClient.legalAddress?.country,
  tariff: legalClient.tariff,
  contractNumber: legalClient.serviceContract?.number,
  contractDate: legalClient.serviceContract?.conclusionDate,
  accountNumber: legalClient.personalAccount.number,
  accountOpeningDate: legalClient.personalAccount.openingDate,
  centralDepositoryAccountNumber: legalClient.centralDepositoryAccountNumber,
  centralDepositoryAccountOpeningDate:
    legalClient.centralDepositoryAccountNumberOpeningDate,
  code: legalClient.code,
});
